import React from "react";
import { Select } from "antd";
import dayjs from "dayjs";

// Опции для селектора года (возвращает 6 предыдущих лет)
export const YearSelectOptions = () => {
  const res: number[] = [];
  for (let i = 1; i < 7; i++) {
    res.push(dayjs().get("year") - i);
  }
  return res.map((year) => {
    return (
      <Select.Option key={year} value={year}>
        {year}
      </Select.Option>
    );
  });
};
